import { Col, Card, Row } from 'react-bootstrap'
import './PortalCard.scss'
import { format } from 'date-fns'
import { RecordType } from '@/components/shared/DeleteRecordModal'
import RecordActionButtons from '@/components/RecordActionButtons'
import { memo } from 'react'
import { Portal } from '@/types'

interface Props {
  portal: Portal,
}

export default memo(function PortalCard({ portal }: Props) {
  const {
    slug,
    title,
    description,
    createdAt,
    viewCount,
  } = portal

  return (
    <>
      <Row key={slug} className="mb-3 justify-content-center">
        <Col xs={12} md={10} lg={8}>
          <Card className="shadow-sm ProjectCard">
            <Card.Body>
              <Card.Title className="ProjectCard__Title">{title}</Card.Title>
              <hr className="border-secondary border-1" />
              {description && <Card.Text className="PortalCard__Description">{description}</Card.Text>}
              <div className="d-flex justify-content-between align-items-center mb-3">
                <small className="text-muted">
                  Created: {
                  createdAt && !isNaN(new Date(createdAt).getTime())
                  ? format(new Date(createdAt), 'dd LLL yyyy')
                  : 'Unknown'
                }
                </small>
                <small className="text-muted d-flex align-items-center gap-1">
                  <i className="fa-solid fa-eye" />{viewCount}
                </small>
              </div>
              <RecordActionButtons
                idOrSlug={slug}
                recordType={RecordType.Portal}
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  )
})
